import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { separateFirstParagraph } from 'site-modules/shared/utils/string';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';

import './collapsed-long-content.scss';

export function CollapsedLongContent({ content, isEnabled = true, hasColoredLinks = false }) {
  if (!isEnabled) {
    return <ContentFragment>{content}</ContentFragment>;
  }

  const [mainContent, restContent] = separateFirstParagraph(content);

  return (
    <Fragment>
      <ContentFragment
        classes={classnames({ 'collapsed-main-content': restContent, 'colored-links': hasColoredLinks })}
      >
        {mainContent}
      </ContentFragment>
      {!!restContent && (
        <ContentCollapse
          classes={classnames('collapsed-rest-content', { 'colored-links': hasColoredLinks })}
          btnContainerClasses="py-0 px-0_5 mt-0_5 mb-1"
          btnClasses="p-0 text-primary-darker read-more-btn"
          btnTextClasses="fw-normal"
          btnSize="lg"
          btnArrowClasses="xsmall"
          justify="justify-content-start"
          textClosed="Read more"
          textOpen="Read less"
          showBtnBelow
        >
          <ContentFragment>{restContent}</ContentFragment>
        </ContentCollapse>
      )}
    </Fragment>
  );
}

CollapsedLongContent.propTypes = {
  content: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool,
  hasColoredLinks: PropTypes.bool,
};
